import querystring from 'querystring';
import axios from 'axios';
import { konamiApi } from '../../api';
// import Log from '../utils/debug';

const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
const DELETE_NOTIFICATIONS_SUCCESS = 'DELETE_NOTIFICATIONS_SUCCESS';
const NOTIFICATION_SELECTED_ROWS = 'NOTIFICATION_SELECTED_ROWS';
const UPDATE_EVENT_NAME = 'UPDATE_EVENT_NAME';
const FILTER_PRESETS = 'FILTER_PRESETS';
const UPDATE_SELECTED_PRESETS = 'UPDATE_SELECTED_PRESETS';

const Log = console;

const CURRENT_CONTEXT = 'Redux Notification Action -> ';
const DEFAULT_SORT = 'datetime,desc';
const ZERO = 0;

export const fetchNotificationsSuccess = notificationsObj => ({
  type: FETCH_NOTIFICATIONS_SUCCESS,
  notifications: {
    notifications: notificationsObj.notificationRows,
    notificationsCount: notificationsObj.notificationsCount,
  },
});

export const updateEventName = eventName => ({
  type: UPDATE_EVENT_NAME,
  eventName,
});

export const updateFilters = filters => ({
  type: FILTER_PRESETS,
  filters,
});

export const updateSelected = selectedFilters => ({
  type: UPDATE_SELECTED_PRESETS,
  selectedFilters,
});

export const deleteNotificationsSuccess = bool => ({
  type: DELETE_NOTIFICATIONS_SUCCESS,
  deleteNotificationsSuccess: bool,
});

export const notificationRowsSelected = selectedNotificationRows => ({
  type: NOTIFICATION_SELECTED_ROWS,
  selectedNotificationRows,
});

/** MIDDLEWARES */

export const fetchNotifications = () => dispatch => {
  konamiApi
    .get(`${process.env.NOTIFICATION_API_URI}`)
    .then(res => {
      Log.info(`${CURRENT_CONTEXT}-> fetchNotifications success (res)`, res);
      const notificationsCount = res.results.total;
      const notificationRows = res.rows.map(notification => ({
        id: notification.id,
        event_name: notification.event.name,
        venue_name: notification.event.venue.name,
        event_date: notification.event.datetime_venue,
        filter_name: notification.filter.name,
        datetime: notification.datetime_local,
        event_links: notification.event.links,
        sort: DEFAULT_SORT,
        event_id: notification.event.id,
        reps_links: notification.event.reps_links,
      }));
      dispatch(fetchNotificationsSuccess({ notificationRows, notificationsCount }));
    })
    .catch(err => {
      Log.info(`${CURRENT_CONTEXT}-> fetchNotifications fail (err)`, err);
      alert('Error in fetch notifications server request.');
    });
};

export const deleteNotifications = (jwtToken, gridApi, classes) => (dispatch, getState) => {
  const { selectedNotificationRows } = getState().notifications;

  Log.info(`${CURRENT_CONTEXT}-> deleteNotifications (notifications to delete)`, selectedNotificationRows);
  Log.info(`${CURRENT_CONTEXT}-> deleteNotifications (gridApi)`, gridApi);

  gridApi.showLoadingOverlay();

  if (!Array.isArray(selectedNotificationRows) || !selectedNotificationRows.length) {
    Log.info(`${CURRENT_CONTEXT}-> deleteNotifications NO NOTIFICATIONS`);
    alert('No notifications to delete');
  } else {
    Log.info(`${CURRENT_CONTEXT}-> deleteNotifications DELETING NOW`);
    const notificationIDs = { id: selectedNotificationRows.map(notification => notification.id) };
    Log.info(`${CURRENT_CONTEXT}-> deleteNotifications (notificationIDs)`, querystring.stringify(notificationIDs));
    konamiApi
      .delete(`${process.env.NOTIFICATION_API_URI}`, {
        data: querystring.stringify(notificationIDs),
      })
      .then(res => {
        Log.info(`${CURRENT_CONTEXT}-> deleteNotifications success`, res);
        dispatch(fetchNotifications(jwtToken, classes));
        gridApi.hideOverlay();
      })
      .catch(err => {
        Log.info(`${CURRENT_CONTEXT}-> deleteNotifications error`, err);
        alert('Error in delete notifications server request.');
        gridApi.hideOverlay();
      });
  }
};

export const fetchEventNotifications = () => (dispatch, getState) => {
  const { eventName, selectedFilters } = getState().notifications;
  const params = new URLSearchParams();
  params.append('event_name', eventName);
  selectedFilters.forEach(selectedFilter => {
    params.append('filter_id', selectedFilter);
  });
  params.append('sort', DEFAULT_SORT);
  konamiApi
    .get(`${process.env.KONAMI_API_URL + process.env.NOTIFICATION_API_URI}`, {
      params,
    })
    .then(res => {
      Log.info(`${CURRENT_CONTEXT}-> fetchNotifications success (res)`, res);
      const notificationsCount = res.results.total;
      const notificationRows = res.rows.map(notification => ({
        id: notification.id,
        event_name: notification.event.name,
        venue_name: notification.event.venue.name,
        event_date: notification.event.datetime_venue,
        filter_name: notification.filter.name,
        datetime: notification.datetime_local,
        event_links: notification.event.links,
        event_id: notification.event.id,
      }));
      dispatch(fetchNotificationsSuccess({ notificationRows, notificationsCount }));
    })
    .catch(err => {
      Log.info(`${CURRENT_CONTEXT}-> fetchNotifications fail (err)`, err);
      alert('Error in fetch notifications server request.');
    });
};

export const fetchFilters = () => dispatch => {
  konamiApi.get(`${process.env.USER_API_URI}sets/1/keys`).then(res => {
    Log.info(`${CURRENT_CONTEXT}-> fetchNotifications success (res)`, res.keys);
    const presetFilters = res.filters.map(filter => ({
      id: filter.id,
      description: filter.description,
      ignored_events: typeof filter.value.ignore_events === 'undefined' ? [] : filter.value.ignore_events,
    }));
    dispatch(updateFilters(presetFilters));
  });
};

export const ignoreNotifications = (jwtToken, gridApi, classes) => (dispatch, getState) => {
  const { selectedNotificationRows, filters } = getState().notifications;
  Log.info(`${CURRENT_CONTEXT}-> ignoreNotifications (notifications to ignore)`, selectedNotificationRows);
  Log.info(`${CURRENT_CONTEXT}-> ignoreNotifications (gridApi)`, gridApi);
  Log.info(`${CURRENT_CONTEXT}-> ignoreNotifications (filters)`, filters);
  gridApi.showLoadingOverlay();
  if (!Array.isArray(selectedNotificationRows) || !selectedNotificationRows.length) {
    Log.info(`${CURRENT_CONTEXT}-> ignoreNotifications NO NOTIFICATIONS`);
    alert('No notifications to ignore');
    gridApi.hideOverlay();
  } else {
    Log.info(`${CURRENT_CONTEXT}-> ignoreNotifications IGNORING NOW`);
    axios
      .all(
        filters
          .map(filter => ({
            id: filter.id,
            description: filter.description,
            ignoredEvents: filter.ignored_events,
            eventIDs: selectedNotificationRows
              .filter(
                notification =>
                  filter.description === notification.data.filter_name &&
                  filter.ignored_events.find(i => i === notification.data.event_id) !== notification.data.event_id
              )
              .map(notification => parseInt(notification.data.event_id, 10)),
          }))
          .filter(filterNotification => filterNotification.eventIDs.length > ZERO)
          .map(filterNotification =>
            konamiApi.put(`${process.env.KONAMI_API_URL + process.env.USER_API_URI}keys/${filterNotification.id}`, {
              value: {
                ignore_events: [
                  ...filterNotification.ignoredEvents,
                  ...filterNotification.eventIDs.filter((e, i) => filterNotification.eventIDs.indexOf(e) === i),
                ],
              },
              mode: 'update',
            })
          )
      )
      .then(res => {
        Log.info(`${CURRENT_CONTEXT}-> ignoreNotifications success`, res);
        dispatch(fetchNotifications(jwtToken, classes));
        gridApi.hideOverlay();
      })
      .catch(err => {
        Log.info(`${CURRENT_CONTEXT}-> ignoreNotifications error`, err);
        alert('Error in delete notifications server request.');
        gridApi.hideOverlay();
      });
  }
};
